"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourProvider = exports.useTourContext = void 0;
const react_1 = __importStar(require("react"));
const TourPortal_1 = __importDefault(require("components/design-system/tour-onboard/TourPortal"));
const initialState = {
    tourStart: false,
    tourData: null,
    tourIndexStep: 0
};
const defaultUpdate = () => initialState;
const TourContext = (0, react_1.createContext)({
    state: initialState,
    setState: defaultUpdate
});
const TourProvider = ({ children }) => {
    const [state, setState] = (0, react_1.useState)(initialState);
    return (react_1.default.createElement(TourContext.Provider, { value: { state, setState } },
        children,
        react_1.default.createElement(TourPortal_1.default, null)));
};
exports.TourProvider = TourProvider;
const useTourContext = () => {
    var _a, _b;
    const { state, setState } = (0, react_1.useContext)(TourContext);
    const addTourOnboard = (data) => {
        setState({ tourStart: true, tourData: data, tourIndexStep: 0 });
    };
    function getCurrentStepData() {
        const tourData = state.tourData;
        const tourIndexStep = state.tourIndexStep;
        if (!tourData || !(tourData === null || tourData === void 0 ? void 0 : tourData.steps))
            return null;
        return tourData === null || tourData === void 0 ? void 0 : tourData.steps[tourIndexStep];
    }
    function clearTour() {
        setState({ tourStart: false, tourData: null, tourIndexStep: 0 });
    }
    function nextStep() {
        var _a, _b;
        const totalStep = ((_b = (_a = state.tourData) === null || _a === void 0 ? void 0 : _a.steps) === null || _b === void 0 ? void 0 : _b.length) || 0;
        if (state.tourIndexStep == totalStep - 1) {
            return clearTour();
        }
        setState((draft) => (Object.assign(Object.assign({}, draft), { tourIndexStep: draft.tourIndexStep + 1 })));
    }
    function prevStep() {
        setState((draft) => (Object.assign(Object.assign({}, draft), { tourIndexStep: draft.tourIndexStep - 1 })));
    }
    return {
        addTourOnboard,
        tourData: state.tourData,
        tourStart: state.tourStart,
        currentStepData: getCurrentStepData(),
        clearTour,
        nextStep,
        prevStep,
        isLastStep: state.tourIndexStep == (((_b = (_a = state.tourData) === null || _a === void 0 ? void 0 : _a.steps) === null || _b === void 0 ? void 0 : _b.length) || 0) - 1
    };
};
exports.useTourContext = useTourContext;
